import { Injectable, NgZone }     from '@angular/core';
import { Location } from '@angular/common';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs/Rx';
import {Title, Meta} from '@angular/platform-browser';

import {TrackerService} from './tracker';

declare let window: any;

@Injectable()
export class RoutesService {
  currentRoute:BehaviorSubject<any>;
  subscriptions:any[] = [];

  constructor(public router: Router,
              private location:Location,
              private title:Title,
              private meta:Meta,
              private tracker:TrackerService,
              private zone:NgZone) {
    window.routesService = this;
    this.currentRoute = new BehaviorSubject(null);
    let lastChild = null;
    this.subscriptions.push(this.router.events.subscribe(evt => {
      let event:any = evt;
      if (event instanceof NavigationStart) {
        let basePath = this.getBasePath(event.url);
        if (basePath !== this.getCurrentBasePath()) {
          this.currentRoute.next(null);
        }
      } else if (event instanceof NavigationEnd) {
        let newRoute = this.getCurrentRoute();
        if (newRoute !== this.currentRoute.getValue()
            || lastChild !== this.router.routerState.root.children[0]) {
          lastChild = this.router.routerState.root.children[0]
          this.tracker.track('route', {
            url: event.url,
          });
          window.jQuery('body').removeClass((idx, names) => {
            names = names.split(' ').filter(n => n.indexOf('ui-') === 0).join(' ');
            return names;
          });
          window.jQuery('body').addClass('ui-' + newRoute.ui);
          this.title.setTitle(newRoute.meta.title);
          this.meta.updateTag({name: 'title', content: newRoute.meta.title});
          this.meta.updateTag({name: 'description', content: newRoute.meta.description});
          this.meta.updateTag({name: 'keywords', content: (newRoute.meta.keywords || []).join(',')});
          this.currentRoute.next(newRoute);
        }
      }
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  navigate(link, isRedirect=false, extras:any={}) {
    if (!extras.queryParams) {
      extras.queryParams = this.getQueryParams();
    }
    if (isRedirect) {
      extras.replaceUrl = true;
    }
    this.zone.run(() => {
      this.router.navigate(link, extras);
    });
  }

  addQueryParams(params) {
    let link = this.getCurrentPath().split('/');
    let childRoute = this.router.routerState.root.children[0];
    let queryObs:any = childRoute.queryParams;
    let queryParams = window.jQuery.extend({}, queryObs.getValue());
    for (let k in params) queryParams[k] = params[k];
    for (let k in queryParams) if (queryParams[k] === null) delete queryParams[k];
    this.navigate(link, true, {queryParams});
  }

  getCurrentPath() {
    return this.router.url.substring(1).split(';')[0].split('?')[0]
  }

  getPathParams() {
    let paramObs:any = this.router.routerState.root.children[0].params;
    return paramObs.getValue();
  }

  getQueryParams() {
    let paramObs:any = this.router.routerState.root.children[0].queryParams;
    return paramObs.getValue();
  }

  getBasePath(longPath) {
    let best = '';
    Object.keys(window.config.routes).forEach(path => {
      if (path.length > best.length && longPath.indexOf(path) === 0) {
        best = path;
      }
    });
    return best;
  }

  getDefaultRoute() {
    return window.config.routes.default;
  }

  getCurrentBasePath() {
    return this.getBasePath(this.router.url) || window.config.routes.default || Object.keys(window.config.routes)[0];
  }

  getCurrentRoute() {
    let path = this.getCurrentBasePath();
    let route = window.config.routes[path];
    if (typeof route.navigation === 'string') {
      route.navigation = window.config[route.navigation];
    }
    return route;
  }

  getCurrentNavigation() {
    let nav = this.getCurrentRoute().navigation;
    if (typeof nav === 'string') nav = window.config[nav];
    return nav;
  }

  setCurrentNavigation(nav) {
    this.getCurrentRoute().navigation = nav;
  }

  getPathParts(path='') {
    if (path.charAt(0) === '/') path = path.substring(1);
    return path.split('/');
  }

  getLink(uiType) {
    let curRoute = this.getCurrentRoute();
    for (let path in window.config.routes) {
      let route = window.config.routes[path];
      if (route.ui === uiType && (route.openapi === curRoute.openapi || !curRoute.openapi)) {
        let link = this.getPathParts(path);
        link[0] = '/' + link[0];
        return link;
      }
    }
  }

  getBaseLink() {
    let parts = this.getPathParts(this.getCurrentBasePath());
    parts[0] = '/' + parts[0];
    return parts;
  }

  getAPICallLink(apiCall, docsOrConsole) {
    let link = this.getLink(docsOrConsole);
    let base = this.getBasePath(link);
    let route = window.config.routes[base];
    if (typeof route.navigation === 'string') {
      route.navigation = window.config[route.navigation];
    }
    function getLink(items) {
      if (!items) return;
      for (let i = 0; i < items.length; ++i) {
        let item = items[i];
        if (item.operation === apiCall.id) return item;
        let child = getLink(item.children);
        if (child) return child;
      }
    }
    let sublink = getLink(route.navigation);
    if (!sublink) throw new Error("nav not found for " + apiCall.method + ' ' + apiCall.path);
    return link.concat(sublink.path.substring(1).split('/'));
  }

  getNavigationLink(path) {
    let parts = [this.getCurrentBasePath()];
    parts = parts.concat(this.getPathParts(path));
    return parts;
  }

  makeRelativePathAbsolute(path) {
    if (path.charAt(0) === '/') return path;
    let base = this.getCurrentBasePath();
    if (base.charAt(base.length - 1) !== '/') base += '/';
    return base + path;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/routes.ts